import React from "react";
import styled from "styled-components";
import { media } from "./media-queries";
import ShareImage1 from "../images/social-networks/email.svg";
import ShareImage2 from "../images/social-networks/facebook.svg";
import ShareImage3 from "../images/social-networks/linked-in.svg";
import ShareImage4 from "../images/social-networks/twitter.svg";
import ShareImage5 from "../images/social-networks/print.svg";

const Wrapper = styled.div`
  display: flex;
`;

const Item = styled.div`
  flex: 1;
  padding: 0 10px;

  img {
    width: 100%;
  }

  ${media.md} {
    padding: 0 30px;
  }

  ${media.lg} {
    padding: 0 10px;
  }
`;

export const ShareThis = () => {
  const currentLocation = typeof window !== "undefined" && window.location.href;

  return (
    <>
      <p>
        <strong>Share this:</strong>
      </p>
      <Wrapper>
        <Item>
          <a
            href="mailto:?subject=Luke%20Gamble&body=I%20saw%20this%20and%20thought%20you%20may%20like%20to%20see%20it%3A%20[sub]%3Cbr%2F%3E%0ACheck%20out%20%3Ca%20href%3D%22http%3A%2F%2Flukegamble.com%2F%22%3ELuke%20Gamble%3C%2Fa%3E!%3Cbr%2F%3E%0A"
            title="Email"
          >
            <img src={ShareImage1} alt="Email icon" />
          </a>
        </Item>
        <Item>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${currentLocation}`}
            rel="noopener noreferrer"
            target="_blank"
            title="Facebook"
          >
            <img src={ShareImage2} alt="Facebook logo" />
          </a>
        </Item>
        <Item>
          <a
            href={`http://www.linkedin.com/shareArticle?mini=true&url=${currentLocation}`}
            rel="noopener noreferrer"
            target="_blank"
            title="LinkedIn"
          >
            <img src={ShareImage3} alt="LinkedIn logo" />
          </a>
        </Item>
        <Item>
          <a
            href={`https://twitter.com/intent/tweet?url=${currentLocation}&via=LukeGamble`}
            rel="noopener noreferrer"
            target="_blank"
            title="Twitter"
          >
            <img src={ShareImage4} alt="Twitter logo" />
          </a>
        </Item>
        <Item>
          <a
            href="/"
            onClick={(event) => {
              event.preventDefault();
              window && window.print();
            }}
            title="Print"
          >
            <img src={ShareImage5} alt="Print icon" />
          </a>
        </Item>
      </Wrapper>
    </>
  );
};
